import { server } from '../constants';
import { httpClient } from '../utils/HttpClient';

/*______________________
 *  ProcessStatus Data 
 *=====================
 */

/**
 * getList()
 * @param {object} params
 * @param {object} params.package base64 of props {lang, issue_id}
 * @returns
 * Detail: get process-status list by condition
 * API Doc: /muit-iDev/pdpa-im-api/-/wikis/Master/ProcessStatus#getlist
 */
export function getList(params) {
  return httpClient
    .get(`${server.PROCESS_STATUS_URL}/getList`, { params })
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}

/**
 * getListAll()
 * @param {object} params
 * @param {object} params.package base64 of props {lang}
 * @returns
 * Detail: get all process-status all
 * API Doc: /muit-iDev/pdpa-im-api/-/wikis/Master/ProcessStatus#getlistAll
 */
export function getListAll(params) {
  return httpClient
    .get(`${server.PROCESS_STATUS_URL}/getListAll`, { params })
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}
